import { ProductBreadcrumbs } from '../../molecules/ProductBreadcrumbs/ProductBreadcrumbs';
import { MyAssetsTabs } from '../../organisms/MyAssetsTabs/MyAssetsTabs';
import { MyAssetsTemplateProps } from './MyAssetsTemplate.types';

export const MyAssetsTemplate = ({
  breadcrumbs,
  tabs,
  microcopy,
  isManageSeatEnabled,
  ...actions
}: MyAssetsTemplateProps) => {
  return (
    <div className="lg-container min-h-[25rem] space-y-5 pb-10 pt-4 lg:space-y-7 lg:pb-16">
      <ProductBreadcrumbs path={breadcrumbs.path} className="mb-4" />
      <MyAssetsTabs
        {...tabs}
        {...actions}
        isManageSeatEnabled={isManageSeatEnabled}
        microcopy={microcopy}
      />
    </div>
  );
};
